module.exports = __webpack_public_path__ + "img/nav_b2_pic1.17f1a6e2.png";